import React, { useState } from 'react';
import { Container, Grid, Paper, IconButton } from '@material-ui/core';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import HOCLoader from 'Components/Loader/HOCLoader';
import { GetRedirectURL } from 'Components/Api/NSDLAPI';
import DmtIcon from 'Components/DashboardIcon/DmtIcon';

const CustomContainer = HOCLoader(Container);

export const NSDL = () => {
    const classes = commonStyle(); 

    const [severity, setSeverity] = useState('success');
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);

    const NSDLRedirectURL = async () => {

        const requestObj = { Name: 'NSDLURL' };
        setLoadingOpen(true);
        setIsError(false);

        const response = await GetRedirectURL(JSON.stringify(requestObj)); 
        setLoadingOpen(false);

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            return;
        }

        const data = JSON.parse(response.data);
        if (data.Url) {
            window.open(data.Url, '_blank'); 
        } else {
            setSeverity('error');
            setResponseMessage('No URL provided for redirection.');
        }

    };


    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Paper className={classes.PaperStyle}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        Please wait .....
                    </Grid>
                </Grid>
            </Paper>

            <Paper className={classes.PaperStyle}>
                <Grid container>
                    <Grid
                        item
                        xs={12}
                        sm={12}
                        md={6}
                        lg={2}
                        xl={2}
                        className="text-center"
                    >
                        <IconButton
                            color="primary"
                            className="dashmenu"
                            component="div"
                            onClick={NSDLRedirectURL}
                        >
                            <DmtIcon name="NSDL Service" />
                        </IconButton>
                    </Grid>
                </Grid>
            </Paper>
        </CustomContainer>
    );
};